import { useState } from 'react';
import { api } from '../lib/api.js';
import { useAuth } from './useAuth.jsx';

/** The machine-readable code the server sends when a publish is refused. */
export const EMAIL_UNVERIFIED = 'EMAIL_UNVERIFIED';

/** True when an API error is the server refusing a publish for an unconfirmed email. */
export const isEmailUnverifiedError = (err) => err?.details?.code === EMAIL_UNVERIFIED;

/**
 * Whether the signed-in user may publish, plus the resend-link action.
 *
 * `verified` reads from the shared auth user, so when VerifyEmail (or the focus
 * refresh in the banner) calls `refresh()` every publish button enables itself
 * with no reload. Logged-out callers are treated as verified: this only ever
 * disables things, and the server is the real gate.
 */
export function useEmailVerification() {
  const { user, refresh } = useAuth();
  const [state, setState] = useState('idle'); // idle | sending | sent | error

  async function resend() {
    setState('sending');
    try {
      await api.post('/auth/verify/resend');
      setState('sent');
    } catch {
      setState('error');
    }
  }

  return { user, verified: !user || Boolean(user.emailVerified), state, resend, refresh };
}
